import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { Layout } from '../components/layout/Layout';
import * as RouteConstants from '../constants';
import { Admin } from '../pages/admin/Admin';
import { Coaching } from '../pages/coaching/Coaching';
import { Compensation } from '../pages/compensation/Compensation';
import { EdsDashboard } from '../pages/edsDashboard/EdsDashboard';
import { Impersonate } from '../pages/impersonate/impersonate';
import AuthLogin from '../pages/login/AuthLogin';
import RequireAuth from '../pages/login/RequireAuth';
import Unauthorized from '../pages/login/Unauthorized';
import {
    selectCurrentIsAdmin,
    selectCurrentIsEds,
    selectCurrentIsHC,
    selectCurrentRole,
    selectCurrentisComp,
    selectIsAllowCoachingInsight,
    selectIsUserinPercepta,
    selectCurrentUserManagerLevel,
    selectIsDelegate,
    selectIsManagerRecentApprover,
    selectIsAllowCoachingActionModel,
} from '../pages/login/authSlice';
import { ManagerDashboard } from '../pages/managerDashboard/ManagerDashboard';
import { MetricDashboard } from '../pages/metricdashboard/MetricDashboard';
import { ScorecardDashboard } from '../pages/scorecardDashboard/ScorecardDashboard';
import { ScorecardRulesAndActivity } from '../pages/scorecardRulesAndActivity/ScorecardRulesAndActivity';
import { CaMenu } from '../pages/correctiveActions/CaMenu';
import { CallInsight } from '../pages/callIinsight/CallInsight';
// import { HomePage } from '../pages/homePage/HomePage';
import { StackRank } from '../pages/stackRank/StackRank';
import { GamePlanPage } from '../pages/gamePlanPage/GamePlanPage';
import { LandingPage } from '../pages/landingPage/LandingPage';
import { MetricsAdmin } from '../pages/metricsAdmin/MetricsAdmin';
// import { ActionPlan } from '../pages/actionPlan/ActionPlan';
import { CoachingActionPlan } from '../pages/coachingActionPlan/CoachingActionPlan';

// Component containing all application routes
const AllRoutes = () => {
    // Selectors to get user authentication status and roles
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isEds = useSelector(selectCurrentIsEds);
    const role = useSelector(selectCurrentRole);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const isComp = useSelector(selectCurrentisComp);
    const isHC = useSelector(selectCurrentIsHC);
    const isAllowCoachingInsight = useSelector(selectIsAllowCoachingInsight);
    const isUserinPercepta = useSelector(selectIsUserinPercepta);
    const isDelegate = useSelector(selectIsDelegate);
    const isUserRecentApprover = useSelector(selectIsManagerRecentApprover);
    const isAllowCoachingActionModel = useSelector(selectIsAllowCoachingActionModel);

    // Function to render protected routes
    const renderProtectedRoutes = () => (
        <>
            {/* Route for metric dashboard accessible by supervisors and agents */}
            <Route element={<RequireAuth allowedRoles={RouteConstants.ROLES.SupervisorORAgents} />}>
                <Route path={RouteConstants.MYMETRICS} element={<MetricDashboard />}>
                    <Route path=":eid/:scid/:tldate" element={<MetricDashboard />} />
                </Route>
            </Route>
            {/* Route for scorecard dashboard accessible by supervisors */}
            <Route element={<RequireAuth allowedRoles={RouteConstants.ROLES.Supervisor} />}>
                <Route path={RouteConstants.SCORECARDDASHBOARD} element={<ScorecardDashboard />}>
                    <Route path=":scid/:tldate" element={<ScorecardDashboard />} />
                </Route>
            </Route>
            {/* Route for scorecard dashboard accessible by supervisors */}
            <Route element={<RequireAuth allowedRoles={RouteConstants.ROLES.SupervisorORAgentsORManager} />}>
                {/* <Route path={RouteConstants.STACKRANK} element={<StackRank />}/> */}
                <Route path={RouteConstants.STACKRANK} element={<StackRank />}>
                    <Route path=":eid/:svid/:year/:month" element={<StackRank />} />
                </Route>
            </Route>

            {/* <Route element={<RequireAuth allowedRoles={RouteConstants.ROLES.Supervisor} />}>
                <Route path={RouteConstants.GAMEPLAN} element={<GamePlanPage />} />
            </Route>  */}
        </>
    );

    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                {/* Public routes */}
                <Route index element={<AuthLogin />} />
                <Route path=":caid" element={<AuthLogin />} />
                <Route path={RouteConstants.LOGIN} element={<AuthLogin />} />
                <Route path={RouteConstants.CALLBACK} element={<AuthLogin />} />
                <Route path={RouteConstants.UNAUTHORIZED} element={<Unauthorized />} />
                {/* Protected routes */}
                {renderProtectedRoutes()}

                {/* Route for corrective action menu */}
                {
                    <Route
                        element={
                            <RequireAuth allowedRoles={RouteConstants.ROLES.SupervisorORAgentsORManager} />
                        }
                    >
                        <Route path={RouteConstants.CAMENU} element={<CaMenu />}>
                            <Route path=":TabId" element={<CaMenu />} />
                            <Route path=":TabId/:via/:employeeNumber/:coachingActionPlanId/:scorecardVersionId" element={<CaMenu />} />
                            <Route path=":TabId/:via/:employeeNumber/:correctiveActionId/:correctiveActionDate/:categoryId" element={<CaMenu />} />
                        </Route>
                    </Route>
                }
                
                {(((isUserRecentApprover || isAllowCoachingActionModel) && RouteConstants.ROLES.Manager.includes(userManagerLevel)) || RouteConstants.ROLES.SupervisorORAgents.includes(userManagerLevel)) && (
                <Route
                    element={<RequireAuth allowedRoles={RouteConstants.ROLES.SupervisorORAgentsORManager} />}
                >
                    {/* <Route path={RouteConstants.HOMEPAGE} element={<HomePage />} /> */}
                    <Route path={RouteConstants.LANDINGPAGE} element={<LandingPage />} />
                </Route>
                )}
                {/* )} */}

               
                {(process.env.REACT_APP_ENVIRONMENT === RouteConstants.PRODUCTION_APP_ENVIRONMENT ? isAdmin : true) ? (
                    <Route path={RouteConstants.ADMINIMPERSONATE} element={<Impersonate flag={false} />} />
                ) : (
                    ''
                )}

                {/* Route for EDS dashboard accessible by EDS and admins */}
                {((isEds && !isDelegate) || isAdmin) && (
                    <Route path={RouteConstants.EDSDASHBOARD} element={<EdsDashboard />} />
                )}

                {/* Route for manager dashboard accessible by admins and managers */}
                {(isAdmin || role === RouteConstants.MANAGERROLE) && (
                    <Route path={RouteConstants.MANAGERDASHBOARD} element={<ManagerDashboard />}>
                        <Route path=":tabid/:scid/:tldate/:eid" element={<ManagerDashboard />} />
                    </Route>
                )}

                {/* Route for compensation page accessible by admins and compensation team */}
                {(isComp || isAdmin) && (
                    <Route path={RouteConstants.COMPENSATION} element={<Compensation />} />
                )}

                {/* Route for scorecard rules and activity accessible by managers, EDS, compensation team, and admins */}
                {(role === RouteConstants.MANAGERROLE || isComp || isEds || isAdmin) && (
                    <Route path={RouteConstants.SCORECARDRULES} element={<ScorecardRulesAndActivity />} />
                )}

                {/* Route for admin panel accessible by admins, EDS, compensation team, and managers */}
                {(isAdmin || isHC) && <Route path={RouteConstants.ADMIN} element={<Admin />} />}

                {/* Route for metrics admin page accessible by admins and HC */}
                {(isAdmin || isHC) && <Route path={RouteConstants.METRICSADMIN} element={<MetricsAdmin />} />}

                {/* Route for coaching page accessible by supervisors, agents, managers, HC, and admins */}
                {(role === RouteConstants.MANAGERROLE ||
                    role === RouteConstants.SUPERVISORROLE ||
                    role === RouteConstants.AGENTROLE ||
                    isAdmin) && (
                    <Route path={RouteConstants.COACHING} element={<Coaching />}>
                        <Route path=":TabId?/:teamOptionId?/:entityId?/:entityDate?" element={<Coaching />} />
                    </Route>
                )}

                {/* Route for Action Plan - Supervisor Only */}
                {isAllowCoachingActionModel ===true && (role === RouteConstants.SUPERVISORROLE || role === RouteConstants.AGENTROLE || role === RouteConstants.MANAGERROLE) ? (
                    <>
                        <Route path={RouteConstants.ACTIONPLAN} element={<CoachingActionPlan />} />
                        <Route path={`${RouteConstants.ACTIONPLAN}/:stepId/:planId`} element={<CoachingActionPlan />} />
                    </>
                ) : null}

                {/* Route for call insight page accessible by ASD users, Directors and above roles */}
                {isAllowCoachingInsight === true || RouteConstants.ROLES.DirectorOrAbove.includes(userManagerLevel) ? (
                    <Route path={RouteConstants.CALLINSIGHT} element={<CallInsight />} />
                ) : (
                    ''
                )}

                {isAllowCoachingActionModel ===false && isUserinPercepta !== true &&
                RouteConstants.ROLES.SupervisorORManager.includes(userManagerLevel) ? (
                    <Route path={RouteConstants.GAMEPLAN} element={<GamePlanPage />} />
                ) : (
                    ''
                )}

                {/* Default route for login */}
                <Route path="*" element={<AuthLogin />} />
            </Route>
        </Routes>
    );
};

export default AllRoutes;
